// Reusable handler for form data creation
import _ from "lodash";

export const createFormData = (values) => {
  const formData = new FormData();
  const finalData = _.omit(
    {
      ...values,
      description: values.description || " ",
      mediaType: "IMAGE",
    },
    "files"
  );
  if (values.files) {
    for (const file of values.files) {
      formData.append("files", file.file);
    }
  }
  const blob = new Blob([JSON.stringify(finalData)], {
    type: "application/json",
  });
  formData.append("data", blob);
  return formData;
};
